import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { PagedCollectionQueryResult } from '@skylab-shared/business';
import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { ProductQLCollectionItem } from './product-quick-list.query';

export type ProductWithSameNameQueryProperties = { exactName: string, omitedClientId?: number };
export type ProductWithSameSymbolQueryProperties = { symbol: string, omitedClientId?: number };
type ProductsWithSamePropertyQueryProperties = ProductWithSameNameQueryProperties | ProductWithSameSymbolQueryProperties;

export class ProductsWithSamePropertyQuery extends Query<boolean> {
    constructor(readonly params: ProductsWithSamePropertyQueryProperties) {
        super();
    }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ProductsWithSamePropertyQuery)
export class ProductsWithSamePropertyQueryHandler implements QueryHandler<ProductsWithSamePropertyQuery, boolean> {
    #Url = TaggedUrl.join('products/quickList', [Tags.Api, Tags.NotHandle404]);
    #http =  inject(Http) as HttpService;

    async handleAsync(query: ProductsWithSamePropertyQuery): Promise<boolean> {
        const params = isSymbolParams(query.params) ? { symbol: query.params.symbol} : { exactName: query.params.exactName};

        const { data } = await this.#http.get<PagedCollectionQueryResult<ProductQLCollectionItem>>(this.#Url, { params });
        return data?.items?.filter(product => product.id !== query.params.omitedClientId)?.length >= 1;
    }
}

function isSymbolParams(params: ProductsWithSamePropertyQueryProperties): params is ProductWithSameSymbolQueryProperties {
    return params?.hasOwnProperty(<keyof ProductWithSameSymbolQueryProperties>'symbol');
}
